/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Col_LinkInputs */

const en_directory_external_directories_col_link = /** @type {(inputs: Directory_External_Directories_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

const zh_directory_external_directories_col_link = /** @type {(inputs: Directory_External_Directories_Col_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接`)
};

/**
* | output |
* | --- |
* | "Link" |
*
* @param {Directory_External_Directories_Col_LinkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_col_link = /** @type {((inputs?: Directory_External_Directories_Col_LinkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Col_LinkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_col_link(inputs)
	return zh_directory_external_directories_col_link(inputs)
});
export { directory_external_directories_col_link as "directory.external_directories.col_link" }